import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      periodes: [],
      paginatedListPeriodes: [],
      loading: false,
      currentPage: this.$route.hash ? this.$route.hash.split('#')[1] : 1,
      perPage: 15,
      totalItems: 0,
      pages: 1

    }
  },
  methods: {
    async getPeriodes () {
      this.loading = true
      this.$store.dispatch('user/getPeriodes').then(
        response => {
          this.loading = false
          this.periodes = response
          this.getPaginatedDatas()
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    getPaginatedDatas () {
      // Gestion de la pagination
      if (this.periodes) {
        this.totalItems = this.periodes.length
        this.pages = Math.ceil(this.totalItems / this.perPage)
        this.putDatasInPaginatedList(0)
      }
    },
    putDatasInPaginatedList (beginIndex) {
      this.paginatedListPeriodes = []
      beginIndex = this.perPage * beginIndex
      let endIndex = parseInt(beginIndex) + this.perPage
      if (this.periodes.length <= this.perPage) {
        this.paginatedListPeriodes = this.periodes
      } else {
        if (endIndex > this.periodes.length) {
          endIndex = this.periodes.length
        }
        for (let index = beginIndex; index < endIndex; index++) {
          this.paginatedListPeriodes.push(this.periodes[index])
        }
      }
    },
    changeAvailablePage () {
      this.putDatasInPaginatedList(this.currentPage - 1)
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.loading = false
    if (!this.periodes.length) {
      this.getPeriodes()
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Liste des périodes'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
